enum StoreNamespaceEnum {
  Catalog = 'CATALOG',
}

export default StoreNamespaceEnum;
